import {IReduxThemeState} from '../../@interfaces';

const isDarkTheme = document?.body?.classList.contains('dark-theme') === true;

const state: IReduxThemeState = {
	dark: isDarkTheme,
	light: !isDarkTheme,
	mobileVersionMaxWidth: 992,
	isMobileVersion: false,
	sidebar: {
		mobile: {
			open: false,
		},
		desktop: {
			size: 'big',
		},
	}
};

export default state;
